import type { Home } from 'features/home/types'
import { Home as SwcHome } from '@racepointenergy/swc/scs/types/home'
import { memo, useMemo } from 'react'
import {
  DefaultHostSvg,
  hostImageByEnum,
  hostImageByProfileModel,
  hostImageByType,
} from './hostImages'

import { HostIconImg, HostIconImgWrap } from './styles'

interface HostIconProps {
  home: Home | SwcHome | undefined
  size?: number
}

export function HostIcon(props: HostIconProps) {
  const { home } = props

  const hostInfo = home?.hostInfo
  const hostType = home?.hostType

  const hostProfileModel = hostInfo?.hostProfileModel
  const hostEnum = hostInfo?.hostMachineType
  const profileImage = useMemo(
    () => hostProfileModel && hostImageByProfileModel[hostProfileModel],
    [hostProfileModel]
  )
  const enumImage = useMemo(
    () =>
      typeof hostEnum === 'number' &&
      hostEnum >= 0 &&
      hostEnum < hostImageByEnum.length &&
      hostImageByEnum[hostEnum],
    [hostEnum]
  )
  const defaultImage = useMemo(
    () => (hostType && hostImageByType[hostType]) || DefaultHostSvg,
    [hostType]
  )

  const preferredImage = useMemo(() => {
    if (profileImage) {
      return profileImage
    } else if (enumImage) {
      return enumImage
    }
    return undefined
  }, [enumImage, profileImage])

  return (
    <HostIconImgWrap $size={props.size}>
      <HostIconImg src={preferredImage || defaultImage} />
    </HostIconImgWrap>
  )
}

export default memo(HostIcon)
